import { useState, useEffect } from "react";

export function useSimulatedStats(initialStats = { activeUsers: 80, totalCourses: 6, projects: 12 }) {
    const [stats, setStats] = useState(initialStats);
    const [lastUpdated, setLastUpdated] = useState(new Date().toLocaleTimeString());
    const [userHistory, setUserHistory] = useState([{ time: lastUpdated, activeUsers: initialStats.activeUsers }]);
    const [projectHistory, setProjectHistory] = useState([{ time: lastUpdated, projects: initialStats.projects }]);

    useEffect(() => {
        const interval = setInterval(() => {
            const newActiveUsers = Math.max(50, Math.floor(Math.random() * 150));
            const newProjects = stats.projects + Math.floor(Math.random() * 3);

            setStats(prev => ({
                activeUsers: newActiveUsers,
                totalCourses: prev.totalCourses,
                projects: newProjects
            }));

            const now = new Date().toLocaleTimeString();
            setLastUpdated(now);

            setUserHistory(prev => [...prev.slice(-9), { time: now, activeUsers: newActiveUsers }]);
            setProjectHistory(prev => [...prev.slice(-9), { time: now, projects: newProjects }]);
        }, 5000);

        return () => clearInterval(interval);
    }, [stats.projects]);

    return { stats, lastUpdated, userHistory, projectHistory };
}
